import React from 'react';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

import {
  Box,
  ButtonBase,
  Card,
  Chip,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  ButtonNext,
  CarouselProvider,
  Slide,
  Slider,
} from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

import { ReactComponent as RightIcon } from '../../../assets/img/icon/Right.svg';
import { ReactComponent as SiniestrosTotales } from '../../../assets/img/siniestrosIconoGenerico.svg';
import { useIncidentsContext } from '../../../context/incidents/incidents.provider';

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#FFFFFF',
  },
  container: {
    position: 'relative',
    maxWidth: '100%',
    margin: 'auto',
  },
  buttonNext: {
    background: 'transparent',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '4px',
    position: 'absolute',
    top: '50%',
    right: '-16px',
    transform: 'translateY(-50%)',
    padding: '2px',
  },
  text: {
    // color: '#00AEC7',
    color: '#000',
    fontFamily: 'Inter',
  },
}));

const useStyleCards = makeStyles((theme) => ({
  root: {
    background: '#FFFFFF',
  },
  text: {
    color: '#00AEC7',
  },
}));

interface SinisterCardProps {
  data: any;
  img: any;
}

const SinisterCard: React.FC<SinisterCardProps> = ({ data, img }) => {
  const classes = useStyleCards();
  const history = useHistory();
  const { getIncidentById } = useIncidentsContext();

  const selectedIncidentByID = (id) => {
    getIncidentById(data?.id, data);
    history.push('/account/incidentDetails/' + data?.id);
  };

  return (
    <Box py={1} px={1}>
      <Box style={{ cursor: 'pointer' }} onClick={selectedIncidentByID}>
        <Card className={classes.root}>
          <Box m={2}>
            <Box
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Box style={{ display: 'flex', alignItems: 'center' }}>
                <Box style={{ marginRight: '25px' }}>
                  <img src={img} alt="part" />
                </Box>
                <Box>
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Box style={{ display: 'flex' }}>
                        <Typography variant="h6" color="primary">
                          {/* <Typography variant="h6" className={classes.text}> */}
                          Póliza {data?.policy_number}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box style={{ display: 'flex' }}>
                      {data?.product?.code === 4 ? (
                        <Typography>
                          Patente Nº {data?.item?.license_plate}
                        </Typography>
                      ) : (
                        <Typography>{data?.product?.description}</Typography>
                      )}
                    </Box>
                  </Grid>
                </Box>
              </Box>
              <Box style={{ display: 'flex' }}>
                <Chip
                  style={{
                    borderRadius: '3px',
                    marginRight: '20px',
                  }}
                  variant="outlined"
                  label={data?.status}
                  size="small"
                />
                <Box>
                  <RightIcon></RightIcon>
                </Box>
              </Box>
            </Box>
          </Box>
        </Card>
      </Box>
    </Box>
  );
};

const SinisterCards = ({ incidents }) => {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const sinisterToShow = incidents?.length;

  return sinisterToShow > 3 ? (
    <Box py={1} px={1}>
      <ButtonBase component={Link} to="account/incidents">
        <Card className={classes.root}>
          <Box m={2}>
            <Box style={{ display: 'flex', alignItems: 'center' }}>
              <Box style={{ marginRight: '25px' }}>
                <SiniestrosTotales></SiniestrosTotales>
              </Box>
              <Box>
                <Grid item xs={12}>
                  <Box
                    mb={3}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box
                      style={{
                        display: 'flex',
                        alignItems: 'baseline',
                        gap: '10px',
                        marginBottom: '-20px',
                      }}
                    >
                      <Typography variant="h6" className={classes.text}>
                        Total siniestros
                      </Typography>
                      <Typography className={classes.text}>
                        {/* <Typography style={{ fontWeight: 500 }}> */}(
                        {incidents?.length})
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Chip
                    style={{
                      borderRadius: '3px',
                    }}
                    variant="outlined"
                    label={'Abierto'}
                    size="small"
                  />
                </Grid>
              </Box>
              <Box style={{ marginLeft: '50px' }}>
                <RightIcon></RightIcon>
              </Box>
            </Box>
          </Box>
        </Card>
      </ButtonBase>
    </Box>
  ) : sinisterToShow > 2 ? (
    <>
      <CarouselProvider
        naturalSlideWidth={80}
        naturalSlideHeight={500}
        totalSlides={3}
        isIntrinsicHeight
        visibleSlides={matches ? 1 : 2}
        infinite
        isPlaying
        interval={5000}
      >
        <div className={classes.container}>
          <Slider>
            {incidents?.map((incident: any, index: number) => (
              <Slide key={index} index={index}>
                <SinisterCard
                  data={incident}
                  img={require(`../../../assets/img/products/${incident.product.code}.svg`)}
                ></SinisterCard>
                {/* img={require(`../../../assets/img/products/${incident.product.code}.png`)} */}
              </Slide>
            ))}
          </Slider>
          <ButtonNext className={classes.buttonNext}>
            <RightIcon />
          </ButtonNext>
        </div>
      </CarouselProvider>
    </>
  ) : (
    <Grid container>
      {incidents?.map((incident: any, index: number) => (
        <Grid key={index} xs={12} md={6} item>
          <SinisterCard
            data={incident}
            img={require(`../../../assets/img/products/${incident.product.code}.svg`)}
          ></SinisterCard>
          {/* img={require(`../../../assets/img/products/${incident.product.code}.png`)} */}
        </Grid>
      )) || null}
    </Grid>
  );
};

export default SinisterCards;
